<template>
  <div class="lang-switch" @click="show = true">
    <van-icon name="exchange" class="lang-icon" />
    <span class="lang-text">{{ currentLabel }}</span>
  </div>
  <van-action-sheet
    v-model:show="show"
    :actions="actions"
    :cancel-text="$t('common.cancel')"
    :description="$t('lang.label')"
    @select="onSelect"
    close-on-click-action
  />
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { setLocale, SUPPORT_LOCALES } from '@/i18n';

const { locale, t } = useI18n();
const show = ref(false);

const actions = computed(() =>
  SUPPORT_LOCALES.map((code) => ({
    name: t(`lang.${code}`),
    code,
  })),
);

const currentLabel = computed(() => t(`lang.${locale.value}`));

const onSelect = (action) => {
  setLocale(action.code);
  show.value = false;
};
</script>

<style lang="scss" scoped>
.lang-switch {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  .lang-icon {
    font-size: 32px;
    margin-right: 6px;
  }
  .lang-text {
    font-size: 26px;
  }
}
</style>
